<template>
  <v-card class="ps-4 mt-4 mb-4" flat>
    <v-row v-for="doc in EntityDocs" :key="doc.doc_name.name">
      <v-col cols="12" md="8">{{ doc.doc_name && doc.doc_name.name }} </v-col>
      <v-btn
        depressed
        color="success"
        title="Download & View"
        outlined
        fab
        small
        class="ma-2"
        @click="openDoc(doc.doc_val)"
        v-if="doc.doc_val"
        ><v-icon> mdi-file-download</v-icon></v-btn
      >
      <v-btn
        outlined
        title="Delete"
        color="red"
        fab
        small
        class="ma-2 elevation-0"
        v-if="doc.doc_val"
        ><v-icon @click="openDeleteDoc(doc)"> mdi-delete</v-icon></v-btn
      >
      <v-menu
        v-model="doc.isactive"
        :close-on-content-click="false"
        fixed
        :nudge-width="400"
        offset-x
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            class="ma-2 elevation-0"
            outlined
            title="Update/upload"
            dark
            v-bind="attrs"
            v-on="on"
            fab
            small
          >
            <v-icon dark small>
              {{ doc.doc_val ? "mdi-pencil" : "mdi-cloud-upload" }}</v-icon
            >
          </v-btn>
        </template>

        <v-card class="pa-4">
          <v-form ref="uploadDoc">
            <v-col cols="12"
              >{{ doc.doc_name && doc.doc_name.name
              }}<span style="color: #f00">*</span>
            </v-col>
            <v-chip
              label
              class="ms-3 mb-2"
              color="primary"
              v-if="doc && doc.doc_val && doc.doc_val"
            >
              <v-icon small class="pe-2">mdi-file</v-icon>
              <p class="mb-0">
                {{ doc && doc.doc_val && doc.doc_val.split("/").pop() }}
              </p>
            </v-chip>
            <v-col cols="12">
              <v-file-input
                v-model="document_val"
                dense
                accept="application/pdf"
                placeholder="Upload File"
                :error-messages="docError"
                outlined
                required
                prepend-icon=""
                @change="fileUpload($event)"
              >
                <!-- <template v-slot:append>
                  <v-icon aria-hidden="false" class="color-primary">
                    mdi-cloud-upload
                  </v-icon>
                </template> -->
              </v-file-input>
            </v-col>
            <v-divider class="mb-0"></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                depressed
                text
                @click="(doc.isactive = false), (document_val = null)"
              >
                Cancel
              </v-btn>
              <v-btn
                depressed
                color="primary"
                text
                @click="uploadDocument(doc)"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-menu>
    </v-row>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h6 text-center">
          {{ $t("want_to_delete_info") }}
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined small color="primary" @click="closeDelete">
            {{ $t("cancel_label") }}</v-btn
          >
          <v-btn
            class="elevation-0"
            color="primary"
            small
            @click="DeleteDocument()"
          >
            {{ $t("okay") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <OverlayPageVue :showOverlay="loader" />
  </v-card>
</template>

<script>
import { webbreakdown } from "@/utils/breakpoints";
import OverlayPageVue from "@/utils/OverlayPage.vue";
import { AUSbusinessDocs } from "@/utils/BusDocuments";
import businessService from "@/services/BusinessService/businessService.js";
import alerts from "@/mixins/alerts";
export default {
  mixins: [alerts],
  data: () => ({
    webbreakdown,
    businessDocument: AUSbusinessDocs(),
    showPopup: false,
    dialogDelete: false,
    EntityDocs: null,
    loader: false,
    dialog: false,
    document_val: null,
    selectedDeteledDoc: null,
    isshowdoc: false,
    SelectedSrc: null,
    EntityName: "",
    document_name: null,
    docError: "",
    docUploadType: "alldocs",
    selectedDoc: {},
    docsupload: {},
    recievedDocs: [],
    menu: false,
    error: false,
    docrules: [(v) => !!v || "Document is required"],
  }),
  components: {
    OverlayPageVue,
  },
  name: "BankDetails",
  props: {
    selctedEntity: {
      type: String,
    },
    hideForm: {
      type: String,
    },
  },

  mounted() {
    this.getBusinessInfo();
    this.returnBusinessDocs(this.businessDocument);
  },
  computed: {},
  methods: {
    openDeleteDoc(doc) {
      this.selectedDeteledDoc = doc;
      this.dialogDelete = true;
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    openDoc(docurl) {
      console.log(docurl);
      if (docurl) {
        this.loader = true;
        this.SelectedSrc = docurl;
        const url = docurl;
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "excel.pdf");
        document.body.appendChild(link);
        link.click();
        this.loader = false;
      } else {
        return "";
      }
    },
    async getBusinessInfo() {
      try {
        const response = await businessService.getuploaddocs(
          this.$route.query.id
        );
        if (response.data.status_code === 200) {
          this.docsupload = response.data.data[0];
          this.recievedDocs = this.EntityDocs.map((doc) => {
            for (let key in this.docsupload) {
              if (doc.doc_name.code === key) {
                return {
                  doc_name: doc.doc_name,
                  doc_val: response.data.data[0][`${key}`],
                  doc_url: response.data.data[0][`${key}`],
                  isactive: false,
                };
              }
            }
          });
          this.EntityDocs = this.recievedDocs;
        }
      } catch (error) {
        console.error(error);
      }
    },

    async uploadDocument(doc) {
      if (this.document_val && !this.error) {
        this.docError = "";
        this.loader = true;
        let fileData = new FormData();
        fileData.append("document", this.document_val);
        try {
          const response = await businessService.uploadDocs(
            2,
            doc.doc_name.value_code,
            fileData,
            this.$route.query.customerid
          );
          if (response.data.status_code === 200) {
            this.showAlertSuccess(response.data.message);
            this.getBusinessInfo();
            this.document_val = null;
            doc.isactive = false;
            this.loader = false;
          } else {
            this.docError = "";
            this.loader = false;
            this.showAlertError(response.data.message);
          }
        } catch (error) {
          this.docError = "";
          this.document_val = null;
          this.loader = false;
          console.error(error);
        }
      } else {
        this.docError = "Document is required";
      }
    },
    fileUpload(event) {
      console.log(event.name);
      if (event && event.name) {
        this.docError = "";
        this.error = false;
      } else {
        this.docError = "Document is required";
        this.error = true;
      }
    },
    async DeleteDocument() {
      this.loader = true;
      try {
        const response = await businessService.DeleteBusdocs({
          doc_type: this.selectedDeteledDoc.doc_name.value_code,
          customer_id: this.$route.query.customerid,
        });
        if (response && response.data.status_code == 200) {
          this.showAlertSuccess(response.data.message);
          this.loader = false;
          this.dialogDelete = false;
          this.getBusinessInfo();
        } else {
          this.loader = false;
        }
      } catch (error) {
        this.loader = false;
        this.showAlertError(
          "Error: Something went wrong please try again later."
        );
        console.warn("Error", error);
      }
    },
    open() {
      this.$refs.selfiefile.$el.querySelector("input").click();
    },
    returnBusinessDocs(documents) {
      this.EntityDocs = documents.map((docval) => {
        return {
          doc_name: docval,
          doc_val: null,
          doc_url: null,
          isactive: false,
        };
      });
      this.getBusinessInfo();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/global.scss";

.invalid-feedback-name {
  display: flex;
  flex-direction: column;
  text-align: initial;
  font-size: 13px;
  background-color: #f5f5f5;
  color: #dc3545;
}
</style>
